<nav class="dropdown-selection">
  <img
    [src]="coverUrl$ | async"
    [class.placeholder]="hasCoverUrl$"
    [attr.alt]="(reference$ | async) + ' cover'">
  <chapps-select-input
    [items]="options"
    [multiple]="false"
    [control]="selectionFormControl"
    [placeholder]="placeHolder | translate"
    [clearable]="false"
    (changed)="selection.emit($event)"
  >
  </chapps-select-input>
  <ng-container *ngIf="hasReference$ | async">
    <ng-content select="[reference-icon]"></ng-content>
    <label class="reference">{{ reference$ | async }}</label>
  </ng-container>
</nav>
